function isLinkWithinDomain(href: string | null): boolean {
  if (!href) return true; // If href is null or empty, consider it within domain

  try {
    const url = new URL(href, window.location.href);
    return url.origin === window.location.origin;
  } catch (e) {
    // If the URL constructor throws an error, consider it within domain
    return true;
  }
}

export function validateExternalLinks() {
  window.addEventListener("load", function () {
    const anchors = document.getElementsByTagName("a");
    for (let i = 0; i < anchors.length; i++) {
      const anchor = anchors[i];
      const href = anchor.getAttribute("href");
      if (!isLinkWithinDomain(href)) {
        const target = anchor.getAttribute("target");
        const rel = anchor.getAttribute("rel");
        if (target !== "_blank") {
          console.warn(
            `External link "${href}" does not have target="_blank".`,
            anchor,
          );
        }
        if (!rel || !rel.includes("noreferrer") || !rel.includes("noopener")) {
          console.warn(
            `External link "${href}" does not have rel="noreferrer noopener".`,
            anchor,
          );
        }
        anchor.setAttribute("target", "_blank");
        anchor.setAttribute("rel", "noreferrer noopener");
      }
    }
  });
}
